/* eslint-disable default-param-last */
// Action types
const SET_CONTACTS_TYPE = "spirit/searchContactsRetention/SET_CONTACTS_TYPE";
const SET_FILTERED_LIST = "spirit/searchContactsRetention/SET_FILTERED_LIST";
const SET_SELECTED_CONTACT =
  "spirit/searchContactsRetention/SET_SELECTED_CONTACT";
const CLEAN_SELECTED_CONTACT =
  "spirit/searchContactsRetention/CLEAN_SELECTED_CONTACT";
const SAVE_FILTER = "spirit/searchContactsRetention/SAVE_FILTER";
const SAVE_FACETS = "spirit/searchContactsRetention/SAVE_FACETS";
const SAVE_TOTAL = "spirit/searchContactsRetention/SAVE_TOTAL";
const CLEAR_FILTER = "spirit/searchContactsRetention/CLEAR_FILTER";
const SAVE_TIMELINE_EVENTS =
  "spirit/searchContactsRetention/SAVE_TIMELINE_EVENTS";
const SET_SEARCH_VALUE = "spirit/searchContactsRetention/SET_SEARCH_VALUE";
const OPEN_SELECT_TYPE = "spirit/searchContactsRetention/OPEN_SELECT_TYPE";

// InitialState
export const initialState = {
  contactsType: "",
  filteredContacts: [],
  openMinimizedFilter: { type: "", isOpen: false },
  selectedContact: undefined,
  timeline: [],
  total: 0,
  currentTotal: 0,
  facets: {
    status: [],
    funnel: [],
    product: [],
    ticket: [],
    classification: [],
    studentStatus: [],
    attendance: [],
    hasDps: [],
    target: [],
  },
  filters: {
    offset: 0,
    limit: 50,
    page: 1,
    campaignStatus: "1",
    campaignBase: "GRADUACAO",
  },
  searchValue: {
    brand: "",
    priority: "",
    ulife: "",
    activities: "",
    engagement: "",
    product: "",
    campus: "",
    ticket: "",
    financial: "",
    course: "",
    channel: "",
    aginFin: "",
    generalSearch: "",
    order: "recentes",
    cicle: "",
    target: "",
    campSearch: "",
    campaignName: "",
    currentDates: {
      dt_ulife_min: undefined,
      dt_ulife_max: undefined,
      dt_activity_min: undefined,
      dt_activity_max: undefined,
      dt_test_min: undefined,
      dt_test_max: undefined,
      dt_mat_min: undefined,
      dt_mat_max: undefined,
    },
  },
  openSelect: { type: "", isOpen: false },
};

// Reducers
export default (state = initialState, action) => {
  const { filters } = state;
  const { selectedContact } = state;
  switch (action.type) {
    case SET_CONTACTS_TYPE:
      return {
        ...state,
        contactsType: action.info,
      };
    case SET_FILTERED_LIST:
      return {
        ...state,
        filteredContacts: action.info,
      };
    case SET_SELECTED_CONTACT:
      if (selectedContact) {
        return {
          ...state,
          selectedContact: selectedContact.concat(action.info),
        };
      }
      return {
        ...state,
        selectedContact: action.info,
      };

    case CLEAN_SELECTED_CONTACT:
      return {
        ...state,
        selectedContact: undefined,
        timeline: [],
      };
    case SAVE_FILTER:
      if (
        action.filterType !== "campus" &&
        action.filterType !== "search" &&
        action.filterType !== "pagination" &&
        action.filterType !== "product" &&
        action.filterType !== "course" &&
        action.filterType !== "channel" &&
        action.filterType !== "aginFin" &&
        action.filterType !== "brand" &&
        action.filterType !== "priority" &&
        action.filterType !== "ulife" &&
        action.filterType !== "activities" &&
        action.filterType !== "engagement" &&
        action.filterType !== "order" &&
        action.filterType !== "cicle" &&
        action.filterType !== "financial" &&
        action.filterType !== "dt_ulife_min" &&
        action.filterType !== "dt_ulife_max" &&
        action.filterType !== "dt_activity_min" &&
        action.filterType !== "dt_activity_max" &&
        action.filterType !== "dt_test_min" &&
        action.filterType !== "dt_test_max" &&
        action.filterType !== "dt_mat_min" &&
        action.filterType !== "dt_mat_max" &&
        action.filterType !== "campSearch" && // busca do detalhe de campanha
        action.filterType !== "target" && // alvo
        action.filterType !== "campaignType" && // tipo da campanha
        action.filterType !== "campaignStatus" &&
        action.filterType !== "campaignBase" &&
        action.filterType !== "campaignName"
      ) {
        if (action.filterValue === undefined) {
          filters[action.filterType] = [];
        } else if (filters[action.filterType]) {
          if (filters[action.filterType].includes(action.filterValue)) {
            const filteredArray = filters[action.filterType].filter(
              function (value) {
                return value !== action.filterValue;
              }
            );
            filters[action.filterType] = filteredArray;
          } else {
            filters[action.filterType].push(action.filterValue);
          }
        } else {
          filters[action.filterType] = [action.filterValue];
        }
      } else if (action.filterType === "pagination") {
        filters.offset = action.filterValue.offset;
        filters.limit = action.filterValue.limit;
        filters.page = action.filterValue.page;
      } else {
        filters[action.filterType] = action.filterValue;
      }
      return {
        ...state,
        filters,
      };
    case CLEAR_FILTER:
      return {
        contactsType: state.contactsType,
        filteredContacts: [],
        openMinimizedFilter: { type: "", isOpen: false },
        selectedContact: undefined,
        timeline: [],
        total: 0,
        currentTotal: 0,
        facets: {
          status: [],
          funnel: [],
          product: [],
          ticket: [],
          classification: [],
          studentStatus: [],
          attendance: [],
          hasDps: [],
          target: [],
        },
        filters: {
          offset: 0,
          limit: 50,
          page: 1,
          campaignStatus: "1",
          campaignBase: "GRADUACAO",
        },
        searchValue: {
          brand: "",
          priority: "",
          ulife: "",
          activities: "",
          engagement: "",
          product: "",
          campus: "",
          ticket: "",
          financial: "",
          course: "",
          channel: "",
          aginFin: "",
          generalSearch: "",
          order: "recentes",
          cicle: "",
          target: "",
          campSearch: "",
          campaignName: "",
          currentDates: {
            dt_ulife_min: undefined,
            dt_ulife_max: undefined,
            dt_activity_min: undefined,
            dt_activity_max: undefined,
            dt_test_min: undefined,
            dt_test_max: undefined,
            dt_mat_min: undefined,
            dt_mat_max: undefined,
          },
        },
        openSelect: { type: "", isOpen: false },
      };
    case SAVE_FACETS:
      return {
        ...state,
        facets: action.facets,
      };
    case SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.info,
      };
    case SAVE_TIMELINE_EVENTS:
      return {
        ...state,
        timeline: action.events,
      };
    case SAVE_TOTAL:
      if (state.total > action.total) {
        return {
          ...state,
          currentTotal: action.total,
        };
      }
      return {
        ...state,
        total: action.total,
        currentTotal: action.total,
      };

    case OPEN_SELECT_TYPE:
      return {
        ...state,
        openSelect: action.info,
      };
    default:
      return state;
  }
};

// Action Creators
export const setContactsType = (info) => ({
  type: SET_CONTACTS_TYPE,
  info,
});

export const setFilteredList = (info) => ({
  type: SET_FILTERED_LIST,
  info,
});

export const setSelectedContact = (info) => ({
  type: SET_SELECTED_CONTACT,
  info,
});

export const cleanSelectedContact = (info) => ({
  type: CLEAN_SELECTED_CONTACT,
  info,
});

export const saveFilter = (filterType, filterValue) => ({
  type: SAVE_FILTER,
  filterType,
  filterValue,
});

export const saveFacets = (facets) => ({
  type: SAVE_FACETS,
  facets,
});

export const saveTotal = (total) => ({
  type: SAVE_TOTAL,
  total,
});

export const clearFilter = () => ({
  type: CLEAR_FILTER,
});

export const saveTimelineEvents = (events) => ({
  type: SAVE_TIMELINE_EVENTS,
  events,
});

export const setSearchValue = (info) => ({
  type: SET_SEARCH_VALUE,
  info,
});

export const openSelectType = (info) => ({
  type: OPEN_SELECT_TYPE,
  info,
});
